module.exports = __webpack_public_path__ + "img/6.550bdc9e.jpg";